<div
  v-if="showBreadCrumb"
  :class="[
    'n-p-5xl n-position-relative n-z-index-1',
    { 'n-bg-primary-sa-flag-25': isHighlighted },
  ]"
>
  <n-container class="n-flex n-flex-column n-gap-3xl">
    <v-breadcrumbs :items="breadcrumbs" class="n-p-0">
      <template v-slot:divider>
        <n-icon name="arrow-left-01" size="16" />
      </template>

      <template v-slot:item="{ item }">
        <a
          v-if="item.external"
          :href="item.href"
          :aria-label="item.text"
          :disabled="item.disabled"
          class="n-color-neutral-700 n-text-sm n-text-decoration-none"
        >
          {{ item.text }}
        </a>

        <v-breadcrumbs-item
          v-else
          :aria-label="item.text"
          :disabled="item.disabled"
          class="n-color-neutral-700 n-text-sm"
          @click="onClickBreadcrumb(item)"
        >
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>

    <div v-if="pageTitle" class="n-flex n-flex-column n-gap-xl">
      <n-typography
        variant="display-sm"
        weight="bold"
        as="h1"
        class="n-m-0 n-color-neutral-800"
      >
        {{ pageTitle }}
      </n-typography>

      <n-typography
        v-if="pageDescription"
        variant="text-md"
        as="p"
        class="n-m-0 n-color-neutral-800"
      >
        {{ pageDescription }}
      </n-typography>
    </div>
  </n-container>
</div>
